<div class="row">
    <div class="col-md-12">
        <label class="control-label">{{TR 'Voreinstellungen'}}</label>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <div class="button-list pull-right">
            {{#each presets}}
                {{#if visible}}
                <div id="js-perm-{{name}}"
                    data-p-value="{{name}}"
                    class="{{../className}} js-perm-set btn btn-{{#if selected}}inverse btn-custom{{else}}white{{/if}}">
                    {{text}}
                </div>
                {{/if}}
            {{/each}}
        </div>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <label class="control-label">{{TR 'Zugriffsrechte'}}</label>
        {{#each permissions}}
        {{#COMPARE id "!=" "1301"}} {{! hide remote control element }}
            <div class="row">
                <div class="col-xs-4">
                    <p class="form-control-static">{{PERMISSION_LABEL id}}
                        {{#if userDefName}}
                            {{#COMPARE (PERMISSION_LABEL id) '!=' userDefName}}
                                ({{PERMISSION_LABEL userDefName}})
                            {{/COMPARE}}
                        {{/if}}
                </p>
                </div>
                <div class="col-xs-8">
                    <div class="button-list pull-right">
                        {{#if writeVisible}}
                        <div id="js-full_{{id}}"
                            data-p-value="full"
                            data-p-id="{{id}}"
                            class="{{../className}} js-perm-set btn btn-{{#if isFull}}inverse{{else}}white{{/if}}">
                            <i class="fa fa-check"></i>
                        </div>
                        {{/if}}
                        <div id="js-readonly_{{id}}"
                            data-p-value="ro"
                            data-p-id="{{id}}"
                        class="{{../className}} js-perm-set btn btn-{{#if isReadOnly}}inverse{{else}}white{{/if}}">
                            <i class="fa fa-eye"></i>
                        </div>
                        <div id="js-deny_{{id}}"
                            data-p-value="remove"
                            data-p-id="{{id}}"
                        class="{{../className}} js-perm-set btn btn-{{#if isNone}}inverse{{else}}white{{/if}}">
                            <i class="fa fa-minus"></i>
                        </div>
                    </div>
                </div>
            </div>
        {{/COMPARE}}
        {{/each}}
    </div>
</div>
